import { serviceImageActionsFactory } from '../factories/serviceImageActionsFactory.ts';
import useAddParkingServiceImage from './useAddParkingServiceImage.ts';
import useRemoveParkingServiceImage from './useRemoveParkingServiceImage.ts';
import useParkingServiceImages from './useParkingServiceImages.ts';

export const useParkingServiceImageActions = serviceImageActionsFactory({
  useAdd: useAddParkingServiceImage,
  useRemove: useRemoveParkingServiceImage,
  useImages: useParkingServiceImages,
  queryKey: (id) => ['parkingServices', id],
});
